import { render, staticRenderFns } from "./Explanation.vue?vue&type=template&id=796454b6&scoped=true&"
import script from "./Explanation.vue?vue&type=script&lang=js&"
export * from "./Explanation.vue?vue&type=script&lang=js&"
import style0 from "./Explanation.vue?vue&type=style&index=0&id=796454b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796454b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
